import {
  WorkTypeFilenameTemplateItem,
  ControlPointFilenameTemplateItem,
  InspectionFilenameTemplateItem,
  PunchListFilenameTemplateItem,
} from '../classes/dailyInspection'
import { dateOptions } from '../utils'

export const DailyInspectionWorkType = new WorkTypeFilenameTemplateItem({
  id: 'fb746dbd-1ebf-42d3-bb62-1b6f16ab9a1d',
  name: 'Work Type',
  property: 'name',
  help: 'Name from Daily Inspection Work Type table',
  exampleValue: 'Granular Backfill Borrow',
})

export const DailyInspectionShortName = new WorkTypeFilenameTemplateItem({
  id: '9e7a2441-0e83-43a5-9ba9-2956705938ee',
  name: 'Work Type Short Name',
  property: 'shortName',
  help: 'PDF Naming Convention Name (Short Name) from Daily Inspection Work Type table',
  exampleValue: 'GBB',
})

export const DailyControlPointDate = new ControlPointFilenameTemplateItem({
  id: '8be3da8f-fd6d-4d24-943a-a36454f34530',
  name: 'Report Date',
  property: 'reportDate',
  ...dateOptions({
    name: 'Report Date',
    tableNameSingular: 'Daily Inspection Control Point',
  }),
})

export const DailyControlPointId = new ControlPointFilenameTemplateItem({
  id: 'afcf61af-c3d9-4440-8f0b-0163bc715de5',
  name: 'Control Point ID',
  property: 'controlPointId',
  help: 'Inspection ID from Daily Inspection Control Point table',
  exampleValue: 'PLA-0014',
})

export const DailyInspectionDate = new InspectionFilenameTemplateItem({
  id: 'da0c0657-9825-42b6-80a5-f2fed9a8049c',
  name: 'Report Date',
  property: 'reportDate',
  ...dateOptions({
    name: 'Report Date',
    tableNameSingular: 'Daily Inspection Inspection',
  }),
})

export const DailyInspectionId = new InspectionFilenameTemplateItem({
  id: '4021a0c2-22eb-402d-b14a-f427e58c54d3',
  name: 'Inspection ID',
  property: 'inspectionId',
  help: 'Inspection ID from Daily Inspection Inspection table',
  exampleValue: 'PLA-0014',
})

export const DailyPunchListDate = new PunchListFilenameTemplateItem({
  id: 'a795c8a9-4fa6-47c3-ab2f-e042f49ec233',
  name: 'Report Date',
  property: 'reportDate',
  ...dateOptions({
    name: 'Report Date',
    tableNameSingular: 'Daily Inspection Punch List',
  }),
})

export const DailyPunchListId = new PunchListFilenameTemplateItem({
  id: '9f17133f-a5e3-4321-a2b5-26a0cc183ce1',
  name: 'Punch List ID',
  property: 'punchListId',
  help: 'Inspection ID from Daily Inspection Punch List table',
  exampleValue: 'PLA-0014',
})

export type DailyInspectionFilename =
  | typeof DailyInspectionWorkType
  | typeof DailyInspectionShortName
  | typeof DailyControlPointDate
  | typeof DailyControlPointId
  | typeof DailyInspectionDate
  | typeof DailyInspectionId
  | typeof DailyPunchListDate
  | typeof DailyPunchListId
